<template>
	<div class="mt-4">
		<!-- Late Delivery/Shipping Start -->
		<div class="p-10 shadow rounded">
			<div class="row">
				<div class="col-12 mt-1 col-md-3 Aligner-Header">
					<h3>Delivery/Shipping</h3>
				</div>
				<div class="col-12 mt-1 offset-md-1 col-md-2">
					<Multiselect
						class="w-100"
						:options="filterOptions.type.map(x => x.value)"
						:custom-label="opt => filterOptions.type.find(x => x.value == opt).name"
						v-model="filter.lateDeliveryShipping.type"
						selectLabel="Press To Select"
					/>
				</div>
				<div class="col-12 mt-1 col-md-2">
					<Multiselect
						class="w-100"
						:options="['Semester' , 'Quarterly', 'Monthly']"
						:searchable="true"
						:close-on-select="true"
						:show-labels="false"
						v-model="optionRangeShipping"
						selectLabel="Press To Select"
					/>
				</div>
				<div class="col-12 mt-1 col-md-4" style="padding-left:0">
					<div class="form-group">
						<date-range-picker 
							class="w-100 mr-4"
							v-model="shippingRange"
							style="min-height:43px"
							ref="picker"
							:opens="'left'"
							:ranges="rangeOption[optionRangeShipping]"
							:locale-data="{ firstDay: 1, format: 'MMM DD, YYYY' }"
						>
							<template v-slot:input="picker" style="min-width: 350px;" class="text-center">
								<i class="fa fa-calendar fa-fw ml-n1"></i> 
								{{labelShipping == '' ? '' : labelShipping + ' -'}} {{ moment(picker.startDate).format("DD MMMM YYYY")}} - {{ moment(picker.endDate).format("DD MMMM YYYY")}}
								<b class="caret"></b>
							</template>
						</date-range-picker>
					</div>
				</div>
			</div>
			<div class="row mt-2 ml-4">
				<div class="col-md-4 col-12 row" style="padding-top:6px;">
					<div class="col" style="padding-right:0">
						<button 
							style="border-radius : 6px 0px 0px 6px"
							type="button" 
							class="w-100 btn" 
							:class="{'btn-outline-primary' : deliveryShipping != 'MD', 'btn-primary' : deliveryShipping == 'MD'}" 
							@click="deliveryShipping = 'MD'"
						>
							AHM To MD
						</button>
					</div>
					<div class="col" style="padding-left:0">
						<button 
							style="border-radius : 0px 6px 6px 0px"
							type="button" 
							class="w-100 btn" 
							:class="{'btn-outline-primary' : deliveryShipping != 'D', 'btn-primary' : deliveryShipping == 'D'}" 
							@click="deliveryShipping = 'D'"
						>
							MD To D
						</button>
					</div>
				</div>
				<div class="col-md-6"/>
				<div class="col-12 col-md-2 highlightFilter">
					<button
						type="button"
						class="mt-1 btn btn-warning w-100"
						style="height:42.3px"
						@click="exportExcel('Delivery Shipping')"
					>Download CSV <i class="fas fa-download"></i></button>
				</div>
				
			</div>
			<div class="content-outer mb-4">
				<div class="content-inner" style="padding: 0 3%">
					<delivery-shipping-table
						v-if="deliveryShipping == 'MD' && data.delivery_ahm_to_md"
						class="mb-2"
						:data="data.delivery_ahm_to_md.arrived"
						:type="deliveryShipping"
						:isBySL="filter.lateDeliveryShipping.type == 'by_sl'"
						:text="'Arrived'"
						@insertRegionStats="insertRegionStats"
					></delivery-shipping-table>
					<delivery-shipping-table
						v-if="deliveryShipping == 'MD' && data.delivery_ahm_to_md"
						class="mb-2"
						:data="data.delivery_ahm_to_md.intransit"
						:type="deliveryShipping"
						:isBySL="filter.lateDeliveryShipping.type == 'by_sl'"
						:text="'Intransit'"
						@insertRegionStats="insertRegionStatsIntransit"
					></delivery-shipping-table>

					<delivery-shipping-d-table class="mb-2" :data="data.delivery_md_to_d.arrived" v-if="deliveryShipping == 'D' && data.delivery_md_to_d" :type="deliveryShipping" @insertRegionStats="insertRegionStats" :text="'Arrived'"
					></delivery-shipping-d-table>
					<delivery-shipping-d-table class="mb-2" :data="data.delivery_md_to_d.intransit" v-if="deliveryShipping == 'D' && data.delivery_md_to_d" :type="deliveryShipping" @insertRegionStats="insertRegionStatsIntransit" :text="'Intransit'"
					></delivery-shipping-d-table>
				</div>
			</div>
		</div>
		<!-- Late Delivery/Shipping  End -->

		<!-- Late Delivery/Shipping Transporter MD to D Start -->
		<div class="p-10 shadow rounded mt-4">
			<div class="row">
				<div class="col-12 mt-1 col-md-5 Aligner-Header">
					<h3>Delivery/Shipping Transporter</h3>
				</div>
				<div class="col-12 mt-1 offset-md-1  col-md-2">
					<Multiselect
						class="w-100"
						:options="['Semester' , 'Quarterly', 'Monthly']"
						:searchable="true"
						:close-on-select="true"
						:show-labels="false"
						v-model="optionRangeTransporter"
						:selectLabel="'Press To Select'"
					/>
				</div>
				<div class="col-12 mt-1 col-md-4" style="padding-left:0">
					<div class="form-group">
						<date-range-picker 
							class="w-100 mr-4"
							v-model="transporterRange"
							style="min-height:43px"
							ref="picker"
							:opens="'left'"
							:ranges="rangeOption[optionRangeTransporter]"
							:locale-data="{ firstDay: 1, format: 'MMM DD, YYYY', customRangeLabel: 'Custom Range' }"
							
						>
							<template v-slot:input="picker" style="min-width: 350px;" class="text-center">
								<i class="fa fa-calendar fa-fw ml-n1"></i> 
								
								{{labelTransporter == '' ? '' : labelTransporter + ' -'}} {{ moment(picker.startDate).format("DD MMMM YYYY")}} - {{ moment(picker.endDate).format("DD MMMM YYYY")}}
								<b class="caret"></b>
							</template>
						</date-range-picker>
					</div>
				</div>
			</div>
			
			<div class="row mt-2 ml-4">
				<div class="col-md-4 col-12 row" style="padding-top:6px;">
					<div class="col" style="padding-right:0">
						<button 
							style="border-radius : 6px 0px 0px 6px"
							type="button" 
							class="w-100 btn" 
							:class="{'btn-outline-primary' : transporter != 'MD', 'btn-primary' : transporter == 'MD'}" 
							@click="transporter = 'MD'"
						>
							AHM To MD
						</button>
					</div>
					<div class="col" style="padding-left:0">
						<button 
							style="border-radius : 0px 6px 6px 0px"
							type="button" 
							class="w-100 btn" 
							:class="{'btn-outline-primary' : transporter != 'D', 'btn-primary' : transporter == 'D'}" 
							@click="transporter = 'D'"
						>
							MD To D
						</button>
					</div>
				</div>
				<div class="col-md-4 col-12"></div>
				<div class="col-12 offset-md-1 col-md-2 row">
					<div class="col-12 col-md highlightFilter">
					<Multiselect
						v-if="transporter == 'MD'"
						class="mt-1 "
						:options="options.transporter"
						:searchable="true"
						:close-on-select="true"
						:show-labels="false"
						v-model="filter.lateDeliveryShippingTransporterAHM.transporter"
						placeholder="All Transporter"
						:selectLabel="'Press To Select'"
					/>
					<Multiselect
						v-else
						class="mt-1 "
						:options="options.transporter"
						:searchable="true"
						:close-on-select="true"
						:show-labels="false"
						v-model="filter.lateDeliveryShippingTransporterMD.transporter"
						placeholder="All Transporter"
						:selectLabel="'Press To Select'"
					/>
					</div>
				</div>
				<div class="col-12 col-md-2 highlightFilter">
					<button
						type="button"
						class="mt-1 btn btn-warning w-100"
						style="height:90%"
						@click="exportExcel('Delivery Shipping Transporter')"
					>Download CSV <i class="fas fa-download"></i></button>
				</div>
			</div>
			<div class="content-outer">
				<div class="content-inner" style="padding: 0 3%">
					<late-delivery-shipping-transporter-md-to-d :data="data.transporter_ahm_to_md" v-if="transporter == 'MD'" :type="transporter"
					></late-delivery-shipping-transporter-md-to-d>
					<late-delivery-shipping-transporter-md-to-d :data="data.transporter_md_to_d" v-else :type="transporter"
					></late-delivery-shipping-transporter-md-to-d>
				</div>
			</div>
		</div>
		<!-- Late Delivery/Shipping Transporter MD to D End -->
		
		<!-- Leadtime Transporter Start -->
		<div class="p-10 shadow rounded mt-4">
			
			<!-- Filters Start -->
			<div class="row mt-2">
				<div class="col-md-6 col-12 Aligner-Header">
					<h3>Leadtime Transporter</h3>
				</div>
				<div class="col-12 col-md-2">
					<Multiselect
						class="w-100"
						:options="['Semester' , 'Quarterly', 'Monthly']"
						:searchable="true"
						:close-on-select="true"
						:show-labels="false"
						v-model="optionRangeLeadtime"
						selectLabel="Press To Select"
					/>
				</div>
				<div class="col-12 col-md-4" style="padding-left:0">
					<div class="form-group mb-0">
						<date-range-picker 
							class="w-100 mr-4"
							v-model="leadtimeRange"
							style="min-height:43px"
							ref="picker"
							:opens="'left'"
							:ranges="rangeOption[optionRangeLeadtime]"
							:locale-data="{ firstDay: 1, format: 'MMM DD, YYYY' }"
						>
							<template v-slot:input="picker" style="min-width: 350px;" class="text-center">
								<i class="fa fa-calendar fa-fw ml-n1"></i> 
								{{labelLeadtime == '' ? '' : labelLeadtime + ' -'}} {{ moment(picker.startDate).format("DD MMMM YYYY")}} - {{ moment(picker.endDate).format("DD MMMM YYYY")}}
								<b class="caret"></b>
							</template>
						</date-range-picker>
					</div>
				</div>
			</div>
			<div class="row ml-4">
				<div class="col-md-8"></div>
				<div class="col-12 col-md-2 highlightFilter">
					<Multiselect
						class="mt-1 "
						:options="options.gudang.map(x => x.code)"
						:custom-label="opt => options.gudang.find(x => x.code == opt).name"
						:show-labels="false"
						v-model="filter.leadtimeTransporter.destination"
						placeholder="Warehouse Destination"
					/>
				</div>
				<div class="col-12 col-md-2 highlightFilter" style="display: flex; flex-direction: column-reverse;">
					<button
						type="button"
						class="mt-1 btn btn-warning w-100"
						style="height: 41px;"
						@click="exportCsv(data.leadtime_transporter, 'Leadtime Transporter Data')"
					>Download CSV <i class="fas fa-download"></i></button>
				</div>
			</div>
			<!-- Filters End -->

			<div class="content-outer mb-4">
				<div class="content-inner" style="padding: 0 3%">
					<leadtime-transporter-table
						class="mb-2"
						:data="data.leadtime_transporter"
					></leadtime-transporter-table>
				</div>
			</div>
		</div>
		<!-- Leadtime Transporter  End -->
	</div>
</template>

<script>
  function isRTL () {
  return document.documentElement.getAttribute('dir') === 'rtl' ||
    document.body.getAttribute('dir') === 'rtl'
  }

  import Multiselect from 'vue-multiselect'
  import deliveryShippingTable from './../children/deliveryShipping/deliveryShippingTable.vue'
  import deliveryShippingDTable from './../children/deliveryShipping/deliveryShippingDTable.vue'
  import lateDeliveryShippingTransporterMdToD from './../children/deliveryShipping/transporterMdToD.vue'
  import leadtimeTransporterTable from './../children/deliveryShipping/leadtimeTransporterTable.vue'
  const XLSX = require('xlsx')
  import listUrl from './../listUrl.js'
  import DateRangePicker from 'vue2-daterange-picker'
  import moment from 'moment'

export default {
	props: ['options' , 'period', 'mobile', 'data' , 'filter', 'rangeOption'],
	components: {
		Multiselect,
		deliveryShippingTable,
		deliveryShippingDTable,
		lateDeliveryShippingTransporterMdToD,
		leadtimeTransporterTable,
		DateRangePicker
	},
	data () {
		return {
			deliveryShipping : 'MD',
			transporter : 'MD',
			regionStats : null,
			regionStatsIntransit : null,
			moment: moment,
			optionRangeTransporter : 'Semester',
			optionRangeShipping : 'Semester',
			optionRangeLeadtime : 'Semester',
			filterOptions : {
				type : [
					{name:'By SL', value: 'by_sl'},
					{name:'By RIT', value: 'by_rit'},
				],
				gudang : this.$store.getters.getGudang(),
			},
			shippingRange : {
				startDate : this.filter.lateDeliveryShippingTransporterMD.start,
				endDate : this.filter.lateDeliveryShippingTransporterMD.end
			},
			transporterRange : {
				startDate : this.filter.lateDeliveryShipping.start,
				endDate : this.filter.lateDeliveryShipping.end
			},
			leadtimeRange : {
				startDate : this.filter.lateDeliveryShipping.start,
				endDate : this.filter.lateDeliveryShipping.end
			},
			labelTransporter : '',
			labelShipping : '',
			labelLeadtime : '',
			config : {
				direction: 'ltr',
				format: 'mm/dd/yyyy',
				separator: ' - ',
				applyLabel: 'Apply',
				cancelLabel: 'Cancel',
				weekLabel: 'W',
				customRangeLabel: 'Custom Range',
				daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
				monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
				firstDay: 0
			}
		}
	},
	mounted () {
		this.$emit('search')
		console.log(this.rangeOption[this.optionRangeTransporter])
	},
	watch : {
		transporterRange : function () {
			this.filter.lateDeliveryShippingTransporterMD.start = new moment(this.transporterRange.startDate).format("Y-MM-DD")
			this.filter.lateDeliveryShippingTransporterMD.end = new moment(this.transporterRange.endDate).format("Y-MM-DD")

			this.filter.lateDeliveryShippingTransporterAHM.start = new moment(this.transporterRange.startDate).format("Y-MM-DD")
			this.filter.lateDeliveryShippingTransporterAHM.end = new moment(this.transporterRange.endDate).format("Y-MM-DD")

			let start =  new moment(this.transporterRange.startDate).format("Y-MM-DD").split('-')
			if(this.optionRangeTransporter == 'Semester')
				this.labelTransporter = parseInt(start[1]) > 6 ? `S2 ${start[0]}` : `S1 ${start[0]}`
			else if(this.optionRangeTransporter == 'Quarterly')
				this.labelTransporter = parseInt(start[1]) < 4 ? `Q1 ${start[0]}` : parseInt(start[1]) < 7 ? `Q2 ${start[0]}` : parseInt(start[1]) < 10 ? `Q3 ${start[0]}` : `Q4 ${start[0]}`
			else 
				this.labelTransporter = `Custom`
		},
		shippingRange : function () {
			this.filter.lateDeliveryShipping.start = new moment(this.shippingRange.startDate).format("Y-MM-DD")
			this.filter.lateDeliveryShipping.end = new moment(this.shippingRange.endDate).format("Y-MM-DD")
			let url = listUrl.stringUrl.leadTime.deliverShipping
			let params = listUrl.param.leadTime.deliverShipping

			let start =  new moment(this.shippingRange.startDate).format("Y-MM-DD").split('-')
			if(this.optionRangeShipping == 'Semester')
				this.labelShipping = parseInt(start[1]) > 6 ? `S2 ${start[0]}` : `S1 ${start[0]}`
			else if(this.optionRangeShipping == 'Quarterly')
				this.labelShipping = parseInt(start[1]) < 4 ? `Q1 ${start[0]}` : parseInt(start[1]) < 7 ? `Q2 ${start[0]}` : parseInt(start[1]) < 10 ? `Q3 ${start[0]}` : `Q4 ${start[0]}`
			else 
				this.labelShipping = `Custom`

		    this.$emit('loadAPI' , url , params )
		},
		leadtimeRange : function () {
			this.filter.leadtimeTransporter.start = new moment(this.leadtimeRange.startDate).format("Y-MM-DD")
			this.filter.leadtimeTransporter.end = new moment(this.leadtimeRange.endDate).format("Y-MM-DD")
			let url = listUrl.stringUrl.leadTime.leadtimeTransporter
			let params = listUrl.param.leadTime.leadtimeTransporter

			let start =  new moment(this.leadtimeRange.startDate).format("Y-MM-DD").split('-')
			if(this.optionRangeLeadtime == 'Semester')
				this.labelLeadtime = parseInt(start[1]) > 6 ? `S2 ${start[0]}` : `S1 ${start[0]}`
			else if(this.optionRangeLeadtime == 'Quarterly')
				this.labelLeadtime = parseInt(start[1]) < 4 ? `Q1 ${start[0]}` : parseInt(start[1]) < 7 ? `Q2 ${start[0]}` : parseInt(start[1]) < 10 ? `Q3 ${start[0]}` : `Q4 ${start[0]}`
			else 
				this.labelLeadtime = `Custom`

		    this.$emit('loadAPI' , url , params )
		},
		"filter.lateDeliveryShipping" : {
		 deep: true,
		  handler: function () {
		    let url = listUrl.stringUrl.leadTime.deliverShipping
		    let params = listUrl.param.leadTime.deliverShipping

		    this.$emit('loadAPI' , url , params )
		  }
		},
		"filter.lateDeliveryShippingTransporterMD" : {
		 deep: true,
		  handler: function () {
		    let url = listUrl.stringUrl.leadTime.deliveryShippingTransporter
		    let params = listUrl.param.leadTime.deliveryShippingTransporter

		    this.$emit('loadAPI' , url , params )
		  }
		},
		"filter.lateDeliveryShippingTransporterAHM" : {
		 deep: true,
		  handler: function () {
		    let url = listUrl.stringUrl.leadTime.deliveryShippingTransporter
		    let params = listUrl.param.leadTime.deliveryShippingTransporter

		    this.$emit('loadAPI' , url , params )
		  }
		},
		"filter.leadtimeTransporter" : {
		 deep: true,
		  handler: function () {
			let url = listUrl.stringUrl.leadTime.leadtimeTransporter
			let params = listUrl.param.leadTime.leadtimeTransporter

		    this.$emit('loadAPI' , url , params )
		  }
		},
	},
	methods : {
		insertRegionStats (data , totalData) {
			this.regionStats = data
			let keys = Object.keys(this.regionStats)
			for(var i = 0 ; i < keys.length ; i++) {
				this.regionStats[keys[i]].avg = Math.round(this.regionStats[keys[i]].avg / totalData[keys[i]] * 100) / 100
				this.regionStats[keys[i]].target = Math.round(this.regionStats[keys[i]].target / totalData[keys[i]] * 100) / 100
			}
		},
		insertRegionStatsIntransit (data , totalData) {
			this.regionStatsIntransit = data
			let keys = Object.keys(this.regionStatsIntransit)
			for(var i = 0 ; i < keys.length ; i++) {
				this.regionStatsIntransit[keys[i]].avg = Math.round(this.regionStatsIntransit[keys[i]].avg / totalData[keys[i]] * 100) / 100
				this.regionStatsIntransit[keys[i]].target = Math.round(this.regionStatsIntransit[keys[i]].target / totalData[keys[i]] * 100) / 100
			}
		},
		async exportExcel (filename) {
			if(filename == 'Delivery Shipping') {
				// let csvData = this.deliveryShipping == 'MD' ? this.data.delivery_ahm_to_md : this.data.delivery_md_to_d
				// let keys = Object.keys(csvData)
				// // console.log(csvData)
				// for(var i = 0 ; i < keys.length ; i++) {
				// 	let wb = XLSX.utils.book_new()
				// 	var ws = XLSX.utils.json_to_sheet(csvData[keys[i]], { raw: "true" });
				// 	XLSX.utils.book_append_sheet(wb, ws, 'Data')
				// 	XLSX.writeFile(wb, `${filename} ${keys[i]}.xls`)
				// }

				let filterUrl = await this.initialiseFilter('?' , this.filter.lateDeliveryShipping)

				let url = this.deliveryShipping == 'MD' ? '/api/highlight/late-delivery-shipping/ahm-to-md/download' : '/api/highlight/late-delivery-shipping/md-to-d/download'

				this.$http.get(url + filterUrl)
				.then((resp) => {
					let csvData = resp.data.data
					// let wb = XLSX.utils.book_new()
					// var ws = XLSX.utils.json_to_sheet(resp.data.data, { raw: "true" });
					// XLSX.utils.book_append_sheet(wb, ws, 'Data')
					// XLSX.writeFile(wb, `${filename}.xls`)
					let keys = Object.keys(csvData)

					for(var i = 0 ; i < keys.length ; i++) {
						let wb = XLSX.utils.book_new()
						var ws = XLSX.utils.json_to_sheet(csvData[keys[i]], { raw: "true" });
						XLSX.utils.book_append_sheet(wb, ws, 'Data')
						XLSX.writeFile(wb, `${filename} ${keys[i]}.xls`)
					}
				})
				.catch((err) => {
					console.log(err)
				})

			}
			else {
				let csvData = this.transporter == 'MD' ? this.data.transporter_ahm_to_md : this.data.transporter_md_to_d
				let wb = XLSX.utils.book_new()
				var ws = XLSX.utils.json_to_sheet(csvData, { raw: "true" });
				XLSX.utils.book_append_sheet(wb, ws, 'Data')
				XLSX.writeFile(wb, `${filename}.xls`)
			}

			
		}
	}
}

function s2ab(s) {
	var buf = new ArrayBuffer(s.length);
	var view = new Uint8Array(buf);
	for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
}
</script>

<style scoped>
	.btn-primary {
		background-color: #FF9700;
		border-color: #FF9700;
	}

	.btn-outline-primary {
		border-color: #FF9700;
		color: #FF9700;
	}

	.btn-outline-primary:hover {
		background-color: #FF9700;
		color: white;
	}

	.btn-outline-primary:focus {
		background-color:#FF9700;
	}
</style>